/**
 * card-product-swatch.js
 *
 * Handles color swatch selection on product cards (snippets/card-product.liquid)
 * and the "Notify me" state for sold-out cards.
 *
 * Swatch clicks keep the hidden variant id input, the submit button state/label and the
 * swatch image in sync with the swatch the shopper actually selects, using the per-card
 * variant JSON emitted by card-product.liquid (script[data-card-variant-json]).
 *
 * Sold-out cards: the button reads "Notify me" and takes the shopper to the product page
 * with that variant selected (where the back in stock sign-up lives). It is no longer a
 * disabled "Sold out" button and it never submits the add to cart form.
 *
 * Attached once via event delegation on document since many card-product.liquid
 * instances can render on a single page (collection grids, related products, etc.).
 */
(function () {
  if (window.cardProductSwatchListenerAttached) return;
  window.cardProductSwatchListenerAttached = true;

  var NOTIFY_TEXT = 'Notify me';

  function productPathFor(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    return link.getAttribute('href').split('?')[0];
  }

  function setLabels(button, text, serviceText) {
    var addLabel = button.querySelector('.add_generally');
    var serviceLabel = button.querySelector('.add_service');
    var soldOutMessage = button.querySelector('.sold-out-message');

    if (soldOutMessage) soldOutMessage.classList.add('hidden');
    if (addLabel) {
      addLabel.classList.remove('hidden');
      addLabel.textContent = text;
    }
    if (serviceLabel) {
      serviceLabel.textContent = serviceText;
    }
  }

  function setNotifyState(button, card, variantId) {
    var path = productPathFor(card);
    button.removeAttribute('disabled');
    button.removeAttribute('aria-disabled');
    button.setAttribute('type', 'button');
    button.setAttribute('data-notify', 'true');
    if (path && variantId) {
      button.setAttribute('data-notify-url', path + '?variant=' + variantId);
    }
    setLabels(button, NOTIFY_TEXT, NOTIFY_TEXT);
    var soldOutMessage = button.querySelector('.sold-out-message');
    if (soldOutMessage) soldOutMessage.textContent = NOTIFY_TEXT;
  }

  function setBuyState(button, addToCartText) {
    button.removeAttribute('disabled');
    button.removeAttribute('aria-disabled');
    button.removeAttribute('data-notify');
    button.removeAttribute('data-notify-url');
    button.setAttribute('type', 'submit');
    setLabels(button, addToCartText, 'Personalise');
  }

  /* Convert cards that are rendered sold out by the server */
  function applyInitialNotify(root) {
    var buttons = root.querySelectorAll('.card-wrapper button.quick-add__submit[disabled]');
    for (var i = 0; i < buttons.length; i++) {
      var button = buttons[i];
      var card = button.closest('.card-wrapper');
      if (!card) continue;
      var form = button.closest('form');
      var input = form ? form.querySelector('input.product-variant-id') : null;
      setNotifyState(button, card, input ? input.value : null);
    }
  }

  applyInitialNotify(document);

  /* Cards loaded later (filters, pagination, quick view) */
  if (window.MutationObserver) {
    var timer = null;
    new MutationObserver(function (mutations) {
      var hasCards = false;
      for (var i = 0; i < mutations.length && !hasCards; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType === 1 && (node.matches('.card-wrapper') || node.querySelector('.card-wrapper'))) {
            hasCards = true;
            break;
          }
        }
      }
      if (!hasCards) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        applyInitialNotify(document);
      }, 100);
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* Notify me button on a card: go to the product page with that variant */
  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest && event.target.closest('.card-wrapper button[data-notify="true"]');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      var url = button.getAttribute('data-notify-url');
      if (url) window.location.href = url;
    },
    true
  );

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('.swatch-item');
    if (!swatch) return;

    var card = swatch.closest('.card-wrapper');
    if (!card) return;

    var variantId = swatch.getAttribute('data-variant-id');
    if (!variantId) return;

    // Update selected swatch state
    var swatches = card.querySelectorAll('.swatch-item');
    for (var i = 0; i < swatches.length; i++) {
      swatches[i].classList.remove('selected');
    }
    swatch.classList.add('selected');

    // Swap the card image to the selected variant's image, if available
    var image = card.querySelector('.card__media .media img');
    var newImage = swatch.getAttribute('data-image');
    if (image && newImage) {
      image.src = newImage;
      image.removeAttribute('srcset');
    }

    // Look up the selected variant's availability from the embedded JSON
    var variant = null;
    var variantDataEl = card.querySelector('[data-card-variant-json]');
    if (variantDataEl) {
      try {
        var variants = JSON.parse(variantDataEl.textContent);
        for (var j = 0; j < variants.length; j++) {
          if (String(variants[j].id) === String(variantId)) {
            variant = variants[j];
            break;
          }
        }
      } catch (error) {
        console.error('card-product-swatch: unable to parse variant JSON', error);
      }
    }

    var isAvailable = variant ? !!variant.available : true;

    // Sync every hidden variant id input in this card (product-form + any quick-add form)
    var variantInputs = card.querySelectorAll('input.product-variant-id');
    for (var k = 0; k < variantInputs.length; k++) {
      variantInputs[k].value = variantId;
      variantInputs[k].disabled = !isAvailable;
      variantInputs[k].dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Sync the submit button(s): Add to cart when available, Notify me when sold out
    var submitButtons = card.querySelectorAll('product-form button.quick-add__submit');
    var strings = window.variantStrings || {};
    var addToCartText = strings.addToCart || 'Add to cart';

    for (var m = 0; m < submitButtons.length; m++) {
      if (isAvailable) {
        setBuyState(submitButtons[m], addToCartText);
      } else {
        setNotifyState(submitButtons[m], card, variantId);
      }
    }
  });
})();